
import {
	submit
} from "@/api/recharge.js"


async function submitFun (params){
	let data = await submit(params)
	return data
}

export default async function pay(data) {
	let {
		pay_method, //支付类型
	} = data
	let results = false
	if (pay_method == 2) {
		//支付宝支付
		results = await submitFun(data)
	}else if (pay_method == 4) {
		//Grabpay
		results = await submitFun(data)
	}else if (pay_method == 3) {
		//Gcash
		results = await submitFun(data)
	}else if (pay_method == 5) {
		results = await submitFun(data)
	}
	return results
}
